module.exports = __webpack_public_path__ + "img/introduction-img@1920w.1007d1bb.png";